





















































































































































































































































































































































































































































































































































































import {
	imprimirEtiquetasDePreco,
	//montarNomeEPrecoDaEtiqueta,
} from '@/shareds/etiquetas/impressao-de-etiquetas-de-preco'
import {
	EtiquetaDePreco,
	FiltrosDeEtiquetasDePreco,
	FormEtiquetaDePreco,
	Fornecedor,
	ItemDaTabelaDePreco,
} from '@/models'
import { displayNomeCompletoDoProduto } from '@/shareds/produto-shareds'
import { Component, Ref, Vue, Watch} from 'vue-property-decorator'
import SeletorDeLojas from "@/components/loja/SeletorDeLojas.vue"
import BuscaDeProdutoDropdown from './BuscaDeProdutoDropdown.vue'
import BuscaDeProduto from '@/components/produto/BuscaDeProduto.vue'
import AlertModule from '@/store/vuex/aplicacao/AlertModule'
import { TabelaDePreco } from '@/models'
import { FindLojaUseCase, type EtiquetaDePrecoServiceAdapter } from '@/usecases'
import { obrigatorio } from '@/shareds/regras-de-form'
import { formatarMoeda } from '@/shareds/formatadores'
import { Inject } from 'inversify-props'
import request from '@/common/request'
import { isVestcasa } from '@/shareds/utils'
import UserLoginStore from '@/store/vuex/authentication/UserLoginStore'
import { TamanhoDaEtiqueta } from '@/models/EtiquetaDePreco'
import SeletorDeFornecedor from '../fornecedor/SeletorDeFornecedor.vue'

const CAMPOS_DE_ETIQUETA = 'CAMPOS_DE_ETIQUETA'
@Component({
	components: {
		BuscaDeProdutoDropdown,
		SeletorDeLojas,
		BuscaDeProduto,
		SeletorDeFornecedor,
	},
})
export default class TelaDeEtiquetas extends Vue{
	@Ref() formularioDeProdutoEQuantidade!: HTMLFormElement
	@Ref() campoDeQuantidade!: HTMLInputElement
	@Ref() campoDeProduto!: HTMLInputElement
	@Ref() campoDeBuscaDoProduto!: BuscaDeProduto

	displayNomeCompletoDoProduto = displayNomeCompletoDoProduto
	tabelaSelecionadas: TabelaDePreco[] = []
	etiqueta: EtiquetaDePreco | null = null
	quantidade: number | '' | null = 1
	busca: string | null = null

	//montarNomeEPrecoDaEtiqueta = montarNomeEPrecoDaEtiqueta
	formatarMoeda = formatarMoeda
	obrigatorio = obrigatorio
	precoDoProduto = false
	incluirNome = true
	formDeEtiquetas: FormEtiquetaDePreco[] = []
	vestcasa = isVestcasa
	findLojaUseCase = new FindLojaUseCase()
	tamanhosDaEtiqueta: TamanhoDaEtiqueta[] = []
	tamanhoDaEtiquetaId: string | null = null
	produtosImportados: any[] = []
	carregandoProdutosImportados = false
	carregandoImpressao = false
	lojaCache: any | null = null

	tipoFiltro: 'produto' | 'nota' = 'produto'
	carregandoProdutosNota = false
	produtosDaNota: any[] = []
	filtrosNota = {
		numeroNota: '',
		serie: '',
	}
	notasBuscadas = false
	fornecedor: Fornecedor | null = null

	filtros: FiltrosDeEtiquetasDePreco = localStorage[CAMPOS_DE_ETIQUETA]
		? JSON.parse(localStorage[CAMPOS_DE_ETIQUETA])
		: {
			layout: 'Etiqueta de Gôndola',
			loja: null,
			incluirPreco: false,
			idTabelas: null,
			produto: null,
			etiqueta: null,
			tamanho: null,
		}

	@Inject('EtiquetaDePrecoServiceAdapter')
	private etiquetaDePrecoService!: EtiquetaDePrecoServiceAdapter
	
	async created() {
		this.tamanhosDaEtiqueta = await this.etiquetaDePrecoService.findListaTamanhosDaEtiqueta()
		const produtosArmazenados = localStorage.getItem("PRODUTOS_IMPORTADOS")

		if(produtosArmazenados !== null){
			try {
				const dados = JSON.parse(produtosArmazenados)
				this.produtosImportados = Array.isArray(dados) ? dados : [dados]
			} catch (error) {
				AlertModule.setError(error)
				this.produtosImportados = []
			}
		}
		
		if (this.produtosImportados.length > 0) {
			this.carregarProdutosImportados()
		}

		if (this.filtros.incluirPreco) {
			this.filtros.incluirPreco = false
		}
	}

	async carregarProdutosImportados() {
		if (!this.produtosImportados.length) return
		this.carregandoProdutosImportados = true

		const promises = this.produtosImportados.map(produto => {
			const etiquetaForm: FormEtiquetaDePreco = {
				layout: this.filtros.layout,
				idTabelas: this.tabelaSelecionadas.map(({ id }) => id),
				produtoId: produto.produtoId,
				sku: produto.sku,
				nomeDoProduto: produto.nomeProduto,
				quantidade: produto.quantidade || 1,
				lojaId: this.filtros.loja ? this.filtros.loja.id : produto.loja.id,
				tamanho: this.filtros.tamanho,
			}

			this.formDeEtiquetas.push(etiquetaForm)
			return this.buscarEtiqueta(etiquetaForm)
		})

		try {
			await Promise.all(promises)
		} catch (error) {
			AlertModule.setError(error)
		} finally {
			this.carregandoProdutosImportados = false
		}
	}


	get tabelas() {
		const loja = this.lojaParaTabela
		if (!loja) return []
		const listas = loja.configuracaoDaLoja?.tabelasDePreco || []
		return listas.map(l => l.tabelaDePreco)
	}

	get nomeDaLoja(){
		const loja = this.lojaParaTabela
		return loja ? loja.nome : ''
	}
	
	get idDaLoja(){
		const loja = this.lojaParaTabela
		if (loja) return loja.id
		return typeof this.filtros.loja === 'string' ? this.filtros.loja : null
	}

	get buscaUnica() {
		return this.vestcasa
	}

	deleteItem(item: any) {
		const idx = this.formDeEtiquetas.indexOf(item)
		if (idx !== -1) {
			this.formDeEtiquetas.splice(idx, 1)
		}
	}

	formatarPrecoENomeDaEtiqueta(preco: ItemDaTabelaDePreco) {
		if(!preco) return ''
		return this.incluirNome 
			? `${this.precoDoProduto ? this.displayNomeDaEtiqueta(preco.tabela) : ''} ${this.precoDoProduto 
				? `- R$ ${formatarMoeda(preco.precoFinalVarejo || 0)} - Limitação ${preco.qtdeLimitadaDoProduto}` 
				: ''}` 
			: `${this.precoDoProduto 
				? `R$ ${formatarMoeda(preco.precoFinalVarejo || 0)} - Limitação ${preco.qtdeLimitadaDoProduto}` 
				: ''}`
	}
		
	displayNomeDaEtiqueta(tabela: TabelaDePreco){
		return tabela.tipoDeCliente?.nome || 'Varejo'
	} 
	
	async incluirProduto() {
		if (!this.filtros.produto) return
		if (!this.quantidade) return
		if(!this.filtros.loja){
			AlertModule.setError('Necessario selecionar uma loja!')
			return
		}
		
		const stringified = JSON.stringify(this.filtros);
		localStorage.setItem(CAMPOS_DE_ETIQUETA, stringified)
		
		const tamanhoAtualizado = this.filtros.tamanho 
			? await this.etiquetaDePrecoService.findTamanhoEtiquetaById(this.filtros.tamanho.id) 
			: null

		const etiquetaForm: FormEtiquetaDePreco = {
			layout: this.filtros.layout,
			idTabelas:  this.tabelaSelecionadas.map( ({ id}) => id),
			produtoId: this.filtros.produto.id,
			sku: "",
			nomeDoProduto: displayNomeCompletoDoProduto(this.filtros.produto),
			quantidade: this.quantidade,
			lojaId: this.filtros.loja ? this.filtros.loja.id : this.produtosImportados[0].loja.id,
			tamanho: tamanhoAtualizado,
		}

		this.formDeEtiquetas.push(etiquetaForm)
		await this.buscarEtiqueta(etiquetaForm)
		
		this.quantidade = 1
		this.filtros.produto = null
		setTimeout(() => {
			this.campoDeQuantidade.focus()
		})
	}

	async buscarEtiqueta(etiquetaForm: FormEtiquetaDePreco) {
		try {
			if (!etiquetaForm.idTabelas) return
			this.etiqueta = await this.etiquetaDePrecoService.create(etiquetaForm)
		} catch (error: any) {
			AlertModule.setError(error)
		}
	}

	async imprimirEtiquetas() {
		if(!this.filtros.loja) {
			AlertModule.setError('Loja não selecionada')
			return
		}
		if(!this.formDeEtiquetas) {
			AlertModule.setError('Nenhum produto selecionado')
			return
		}
		if(!this.filtros.tamanho){
			AlertModule.setError('Necessario selecionar um tamanho!')
			return
		}

		if(!this.idDaLoja){
			AlertModule.setError('Necessario selecionar uma Loja!')
			return
		}

		try {
			this.carregandoImpressao = true
			let etiquetas: EtiquetaDePreco[] = []
			const tamanho = 10;
			const tamanhoAtualizado = this.filtros.tamanho 
				? await this.etiquetaDePrecoService.findTamanhoEtiquetaById(this.filtros.tamanho.id) 
				: null
			for (let i = 0; i < this.formDeEtiquetas.length; i += tamanho) {
				const algunsFormsDeEtiqueta = this.formDeEtiquetas
					.slice(i, i + tamanho)
					.map(etiqueta => ({
						...etiqueta,
						idTabelas: this.tabelaSelecionadas.map(({ id }) => id),
						lojaId: this.idDaLoja,
						incluirPreco: this.filtros.incluirPreco,
						tamanho: tamanhoAtualizado,
						layout: this.filtros.layout,
					}));
				// eslint-disable-next-line no-await-in-loop
				const algumasEtiqueta = await request.post<never, EtiquetaDePreco[]>('/etiquetas', algunsFormsDeEtiqueta)
				etiquetas = [
					...etiquetas,
					...algumasEtiqueta,
				]
			}
			const conformeRegraDoCaixa = this.imprimirConformeRegraDeNegocioDoCaixa ? true : false
			await imprimirEtiquetasDePreco(etiquetas, this.precoDoProduto, this.incluirNome, conformeRegraDoCaixa, this.idDaLoja)	
			
		} catch (error: any) {
			AlertModule.setError(error)
			this.carregandoImpressao = false
		} finally {
			this.carregandoImpressao = false
			localStorage.removeItem('PRODUTOS_IMPORTADOS');
		}
	}
	
	get imprimirConformeRegraDeNegocioDoCaixa() {
		return UserLoginStore.permiteRegraDeNegocio('imprimir-precos-das-etiquetas-conforme-regra-do-caixa')
	}

	@Watch('tabelaSelecionadas', { deep: true })
	onChangePrecoDoProduto() {
		if (this.tabelaSelecionadas.length != 0 && !this.imprimirConformeRegraDeNegocioDoCaixa) {
			this.precoDoProduto = false
		}
	}

	async loja(lojaId){
		this.filtros.loja = await this.findLojaUseCase.findLojaById(lojaId)
	}

	@Watch('filtros.loja', { deep: true })
	async onChangeLoja(val: any) {
		if (!this.filtros.loja || !this.filtros.loja.grupoEconomico) return
		if(this.filtros.tamanho && this.filtros.tamanho.grupoEconomico && this.filtros.loja.grupoEconomico.id != this.filtros.tamanho.grupoEconomico.id){
			this.filtros.tamanho = null
		}
		this.tamanhosDaEtiqueta = await this.etiquetaDePrecoService.findListaTamanhosDaEtiqueta({grupoEconomicoId: this.filtros.loja.grupoEconomico.id})
		if (val && typeof val === 'object') this.lojaCache = val
	}

	@Watch('filtros.incluirPreco')
	async onIncluirPreco(val: boolean) {
		if (val && !this.lojaParaTabela && typeof this.filtros.loja === 'string') {
			this.lojaCache = await this.findLojaUseCase.findLojaById(this.filtros.loja)
		}
	}

	get lojaParaTabela() {
		const l = this.filtros.loja
		return l && typeof l === 'object' ? l : this.lojaCache
	}

	selecionarTipoFiltro(tipo: 'produto' | 'nota') {
		this.tipoFiltro = tipo
		
		if (tipo === 'produto') {
			this.produtosDaNota = []
			this.filtrosNota = {
				numeroNota: '',
				serie: '',
			}
		} else {
			this.filtros.produto = null
			this.quantidade = 1
		}
	}

	async buscarProdutosPorNota() {
		if (!this.filtrosNota.numeroNota || !this.filtrosNota.serie) {
			AlertModule.setError('Digite a serie da NFe e o número da nota')
			return
		}

		if(!this.filtros.loja){
			AlertModule.setError('Necessário selecionar uma Loja');
			return
		}

		if(!this.fornecedor) {
			AlertModule.setError('Necessário selecionar o emitente da nota')
			return
		}

		try {
			this.carregandoProdutosNota = true

			const params = {
				serie: this.filtrosNota.serie,
				numero: this.filtrosNota.numeroNota,
			}

			const produtosParaImpressao = await this.etiquetaDePrecoService.findProdutosNotaBySerieAndNnf(params, typeof this.filtros.loja === 'object' ? this.filtros.loja.id : this.filtros.loja, this.fornecedor?.id)			
			if(Array.isArray(produtosParaImpressao)){
				produtosParaImpressao.forEach(formProduto => {
					const etiquetaForm: FormEtiquetaDePreco = {
						layout: this.filtros.layout,
						idTabelas: this.tabelaSelecionadas.map(({ id }) => id),
						produtoId: formProduto.produtoId,
						sku: formProduto.sku,
						nomeDoProduto: formProduto.nomeDoProduto,
						quantidade: formProduto.quantidade || 1,
						lojaId: this.filtros.loja ? this.filtros.loja.id : formProduto.lojaId,
						tamanho: this.filtros.tamanho,
					}

					this.formDeEtiquetas.push(etiquetaForm)
					return this.buscarEtiqueta(etiquetaForm)
				});
			}

			if(Array.isArray(produtosParaImpressao) && produtosParaImpressao.length >= 1){
				this.notasBuscadas = true
			}else{
				AlertModule.setError('Nenhuma nota encontrada para o filtro selecionado')
			}

		} catch (error: any) {
			AlertModule.setError('Erro ao buscar produtos da nota: ' + error.message)
		} finally {
			this.carregandoProdutosNota = false
		}
	}

	@Watch('tipoFiltro')
	limparProdutos(){
		this.formDeEtiquetas = []
		this.etiqueta = null
		this.notasBuscadas = false
		this.filtrosNota = {
			numeroNota: '',
			serie: '',
		}
	}

}
